import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import deviceDataSlice from "./deviceData/deviceDataSlice";
import authReducer from "./auth/authSlice";

export const store = configureStore({
  reducer: {
    deviceData: deviceDataSlice,
    auth: authReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
